<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew

========================================================================================== -->

<template>
    <vx-card class="course-selector-card overflow-hidden" :style=" `background-color: ${cardColor}!important;`" v-on="$listeners">
      <div slot="no-body" style="cursor: pointer;">
        <img
          :src="item.thumbnail !== null ? item.thumbnail : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'"
          alt="content-img" class="responsive card-img-top" draggable="false"
          style="width: 100%; height: 270px; object-fit: cover;">
      </div>
      <div class="my-2">
        <h5 class="mb-2">{{ item.name }}</h5>
      </div>
      <div class="my-4">
        <div class="flex justify-between">
          <small class="font-semibold">Not Started</small>
          <small class="font-semibold">Completed</small>
        </div>
        <vs-progress :percent="progress" class="block mt-1 shadow-md" color="success"></vs-progress>
      </div>
      <div class="vx-row">
        <!--- <div class="vx-col w-1/2">
          <vs-button class="mt-4 mr-2 shadow-lg font-semibold w-full"
                     icon="icon-info" icon-pack="feather" color="danger"
                     type="gradient" @click="$router.push({name: 'course-view', params: {courseId: item.id }})">
            Progress
          </vs-button>
        </div> --->
        <div class="vx-col w-1/2">
          <vs-button class="mt-4 mr-2 shadow-lg font-semibold w-full"
                     icon="icon-play" icon-pack="feather" color="success"
                     type="gradient" @click="update_active_course(item.id)">Practice
          </vs-button>
        </div>
      </div>
    </vx-card>
</template>

<script>
export default{
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      progress: 0
    }
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    },
    cardColor () {
      const theme = this.$store.state.theme
      if (theme === 'light') return '#FFFFFF'
      if (theme === 'midnight') return '#050035'
      if (theme === 'dark') return '#161719'
    }
  },
  methods: {
    update_active_course (x) {
      const pl = {
        course_id: x
      }

      this.$http.post('users/@me/active-course', pl)
        .then(response => {

          if (response.status === 200) {
            this.$vs.notify({
              color: 'success',
              title: 'Course Changed',
              text: 'You have successfully changed your course',
              position: 'bottom-right'
            })

            this.$router.push('/simulation/search')
          }
        }).catch(exception => {
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to update course',
            text: exception.response.data.error.description,
            position: 'top-right'
          })
        })
    }
  },
  created () {
    this.$http.get(`progress/user/specific/@me/course/progress?id=${this.item.id}`)
      .then(response => {
        this.progress = response.data.data.completion_percent
      })
  }
}
</script>

<style lang="scss" scoped>
.course-selector-card {

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

    .grid-view-img{
      opacity: 0.9;
    }
  }
}
</style>
